import { Component } from '@angular/core';
import { E5coreUiWorkFieldTypeInputBaseComponent } from './e5core-ui-work-field-type-input-base';

@Component({
  selector: 'e5core-ui-work-field-type-input-bootstrap',
  templateUrl: './e5core-ui-work-field-type-input-bootstrap.component.html',
  styleUrls: ['./e5core-ui-work-field-type-input-bootstrap.component.css']
})
export class E5coreUiWorkFieldTypeInputBootstrapComponent extends E5coreUiWorkFieldTypeInputBaseComponent {
}
